import React from 'react';
import { Helmet } from 'react-helmet';

import { METADATA } from '../../constants';

const Meta = () => {
  return (
    <>
      <Helmet>
        <title>{METADATA.title}</title>
        <meta name="description" content={METADATA.description} />
        <meta
          name="keywords"
          content="Luganodes, Staking, Blockchain, Delegate"
        />
        <meta name="robots" content="index, follow" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />
        <meta name="author" content="Luganodes" />
        <meta name="copyright" content="All rights reserved, 2023. Luganodes" />
        <meta http-equiv="content-language" content="en" />

        {/* Open Graph / Facebook */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={METADATA.title} />
        <meta property="og:description" content={METADATA.description} />
        <meta
          property="og:image"
          content="https://ik.imagekit.io/kjsfxvjekmk/Frame_427319179_vtuYk7btL.png?updatedAt=1685582905932"
        />
        <meta property="og:url" content={METADATA.siteUrl} />
        <meta property="og:site_name" content={METADATA.title} />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content={METADATA.title} />
        <meta property="twitter:description" content={METADATA.description} />
        <meta property="twitter:site" content={METADATA.twitterHandle} />
        <meta name="twitter:creator" content={METADATA.twitterHandle} />
        <meta property="twitter:url" content={METADATA.siteUrl} />
        <meta
          property="twitter:image"
          content="https://ik.imagekit.io/kjsfxvjekmk/Frame_427319179_vtuYk7btL.png?updatedAt=1685582905932"
        />

        <meta name="msapplication-TileColor" content="#7000FF" />
        <link rel="manifest" href="/site.webmanifest" />

        <meta http-equiv="X-Frame-Options" content="DENY" />
      </Helmet>
    </>
  );
};

export default Meta;
